module.exports = __webpack_public_path__ + "img/img_a@2x.87cf6da6.png";